/**
 * Services Barrel Export
 * Centralized export point for all API services
 */

export { default as apiClient, ApiClient } from './api/apiClient';
export { default as ENDPOINTS, API_BASE_URL, buildQueryString, buildEndpoint } from './api/endpoints';
export { default as materialService } from './materialService';
export { default as productService } from './productService';
export { default as interactionService } from './interactionService';
export { default as searchService } from './searchService';
export { default as reportService } from './reportService';
export { default as settingsService } from './settingsService';

// Future service exports (when implemented)
// export { default as newsService } from './newsService';
// export { default as dashboardService } from './dashboardService';
// export { default as companyService } from './companyService';
// export { default as insightsService } from './insightsService';
// export { default as userService } from './userService';
